"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadyToLearnCard = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * SVBReadyToLearn
 * @param title: main title of the card component
 * @param image: image for the card
 * @param description: card description
 * @param learnMoreText: learn more text
 * @param learnMoreLink: learn more link
 * @returns Ready to Learn card HTML with content
 */
const ReadyToLearnCard = props => {
  var _props$title, _props$image, _props$description, _props$learnMoreText, _props$learnMoreLink;
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : "";
  const image = (_props$image = props === null || props === void 0 ? void 0 : props.image) !== null && _props$image !== void 0 ? _props$image : "";
  const description = (_props$description = props === null || props === void 0 ? void 0 : props.description) !== null && _props$description !== void 0 ? _props$description : "";
  const learnMoreText = (_props$learnMoreText = props === null || props === void 0 ? void 0 : props.learnMoreText) !== null && _props$learnMoreText !== void 0 ? _props$learnMoreText : "Learn More";
  const learnMoreLink = (_props$learnMoreLink = props === null || props === void 0 ? void 0 : props.learnMoreLink) !== null && _props$learnMoreLink !== void 0 ? _props$learnMoreLink : "#";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "readyToLearn-image-style",
    src: image
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "pt-4"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "heading-medium fw-bold font-family-roboto rl-font-black"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph rl-font-black"
  }, description)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("u", null, /*#__PURE__*/_react.default.createElement("a", {
    href: learnMoreLink,
    className: "sub-heading font-family-roboto"
  }, learnMoreText))));
};
exports.ReadyToLearnCard = ReadyToLearnCard;